import React from "react";

import {
  Anchor,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Container,
  Row
} from "react-bootstrap";
import { Link } from "react-router-dom";

function Tools({tools}) {
  return (
    <Container className="mt-3 mb-5">
      <Card className="mb-3">
        <CardBody>
			<CardTitle className="fw-bold">Tools</CardTitle>
			<CardText>List of tools to use</CardText>
        </CardBody>
      </Card>
      <Row xs={1} md={3} className="g-4">
        {tools.map((_, idx) => (
          <Col key={idx}>
            <Card className="h-100">
              {/* <Card.Img variant="top" src={holder} /> */}
              <Card.Body>
                <Card.Title className="fs-5 fw-bold">{_.title}</Card.Title>
                <Card.Text className="fs-6">{_.description}</Card.Text>
              </Card.Body>
              <Card.Footer className="bg-transparent border-0 m-0 pb-3">
                <Link as={Anchor} to={`/tools/${_.link}`} className={_.isDisabled?"btn btn-dark disabled":"btn btn-dark"} variant="dark">
                  {_.isDisabled ? "Coming Soon" : "Try Now"}
                </Link>
              </Card.Footer>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Tools;
